module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"hide_tooltip":"All righty, hide tooltip now!"},"ru":{"hide_tooltip":"Понятно. Скрыть подсказку!"}}')
  delete Component.options._Ctor
}
